import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./Login.css";
import HeaderB from "../../components/headerb/HeaderB";
// import Header from '../../components/header/Header';

export default function Login() {
  const [logInput, setLogInput] = useState("");
  const [stateInput, setStateInput] = useState(true);
  const [isEnter, setIsEnter] = useState(false);

  const loginInput = (e) => {
    setLogInput(e.target.value);
  };

  const onsubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    // logInput === '1' ? setStateInput(true) : setStateInput(false)
    localStorage.clear();
  }, [logInput]);
  useEffect(() => {
    const chekKey2 = (e) => {
      if (e.keyCode == 13) {
        setIsEnter(true);
      }
      // if(e.keyCode==13 && logInput=='1'){
      //   setIsEnter(true)
      // }
    };
    window.addEventListener("keydown", chekKey2);
    return () => window.removeEventListener("keydown", chekKey2);
  });
  return (
    <Container>
      <HeaderB />

      <Row>
        <Col>
          <form onSubmit={onsubmit} className="login-form">
            <Image
              className="login-image"
              src="./images/logo.png"
              alt="jds"
              rounded
            />
            <div className="login-label-float">
              <input type="text" placeholder="" onChange={loginInput} />
              <label>نام کاربری</label>
            </div>
            <div className="login-label-float">
              <input type="text" placeholder=" " />
              <label>رمز عبور</label>
            </div>
            <Link className="login-link" to={stateInput ? "/selection" : "/"}>
              ورود
            </Link>
            {isEnter && <Navigate to={"/selection"} />}
            <Link className="login-link" to={"/signup"}>
              ثبت نام
            </Link>
          </form>
        </Col>
      </Row>
    </Container>
  );
}
